/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';
import Modal from 'antd/lib/modal/Modal';
import {
  Field, Form, FormikProvider, useFormik,
} from 'formik';
import './export-modal.less';
import { Spin } from 'antd';
import { useActions } from '../../providers/actions-provider/actions.context';
import { useStore } from '../../../store';

interface IExportModal {
  setVisible: (flag: boolean) => void;
  code: string;
  onBuildParams: () => { find: string, sort: string};
}

const ExportModal = ({ setVisible, code, onBuildParams }: IExportModal) : JSX.Element => {
  const { preparedReport } = useStore();
  const { reportActions } = useActions();
  const [reportLink, setReportLink] = useState(false);

  const onCancel = () => {
    setVisible(false);
    setReportLink(false);
  };

  const formikForExport = useFormik({
    initialValues: {
      type: 'tsv',
      padding: false,
    },
    onSubmit: async () => null,
  });
  const { values: { type, padding }, setFieldValue } = formikForExport;
  const onPrepare = async () => {
    const findAndSort = onBuildParams();
    await reportActions.prepareReportByCode(code, findAndSort, type, padding);
    setReportLink(true);
  };
  const onDownload = () => {
    const { name } = preparedReport.data;
    reportActions.getExportReport(name);
    setVisible(false);
  };

  return (
    <Modal
      title={null}
      closable
      centered
      visible
      wrapClassName="wrapper"
      confirmLoading={preparedReport.loading}
      okText={reportLink ? 'Download' : 'Prepare'}
      onOk={reportLink ? onDownload : onPrepare}
      onCancel={onCancel}
    >
      {reportLink && preparedReport.loaded ? (
        <div className="ant-modal-body__content">
          <p className="export-modal_title">Report is Ready for Download</p>
          <p>{`${preparedReport.data.name}`}</p>
        </div>
      ) : (
        preparedReport.loading ? (
          <div style={{
            display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%',
          }}
          >
            <p className="export-modal_title" style={{ textAlign: 'center' }}>Preparing Report...</p>
            <Spin size="large" style={{ margin: '0 auto' }} />
          </div>

        ) : (
          <div className="ant-modal-body__content" style={{ width: '100%' }}>
            <p className="export-modal_title">Report Properties</p>
            <FormikProvider value={formikForExport}>
              <Form style={{ width: '100%' }}>
                <div className="export-modal_types" role="group" aria-labelledby="my-radio-group" style={{ textAlign: 'center' }}>
                  <label className="export-modal_label">
                    <Field type="radio" name="type" value="csv" />
                    csv
                  </label>
                  <label className="export-modal_label">
                    <Field type="radio" name="type" value="tsv" default />
                    tsv
                  </label>
                  <label className="export-modal_label">
                    <Field type="radio" name="type" value="json" onClick={() => setFieldValue('padding', false)} />
                    json
                  </label>
                </div>
                {(type === 'csv' || type === 'tsv') && (
                  <label className="export-modal_label">
                    <Field type="checkbox" name="padding" />
                    padding
                  </label>
                )}
              </Form>
            </FormikProvider>
          </div>
        )
      )}
    </Modal>
  );
};

export default ExportModal;
